import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.formItem.id ? _vm.$i18n_t('NiotaClassic.Consumers.form.titleUpdate') : _vm.$i18n_t('NiotaClassic.Consumers.form.titleCreate')) + "\n    " + _vm._s(_vm.formItem.id ? ` - ${_vm.formItem.source}` : '') + "\n  ")];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-save",
            "disabled": !_vm.formValid
          },
          on: {
            "click": _vm.save
          }
        }, [_vm._v("\n      " + _vm._s(_vm.formItem.id ? _vm.$i18n_t('Common.save') : _vm.$i18n_t('Common.saveAndCreate')) + "\n    ")])];
      },
      proxy: true
    }])
  }, [_c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VForm, {
    ref: "form",
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "pb-0 pt-0",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.title'),
      "color": _vm.color,
      "rules": _vm.titleRules,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": "consumerTitle",
      "required": ""
    },
    model: {
      value: _vm.formItem.title,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "title", $$v);
      },
      expression: "formItem.title"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.titleHint')))])], 1), _c(VCol, {
    staticClass: "pb-0 pt-0",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VSelect, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Consumers.form.type'),
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "items": _vm.consumerTypes,
      "hide-details": "auto",
      "required": ""
    },
    model: {
      value: _vm.formItem.type,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "type", $$v);
      },
      expression: "formItem.type"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.typeHint')))])], 1), _c(VCol, {
    staticClass: "pb-0 pt-0",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "outlined": _vm.inpOutlined,
      "color": _vm.color,
      "filled": _vm.inpFilled,
      "items": _vm.plainAccounts,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "auto-select-first": "",
      "label": _vm.$i18n_t('NiotaClassic.Consumers.form.account'),
      "rules": [() => !!_vm.formItem.accountId || this.$i18n_t('Common.fieldRequired')],
      "item-text": "name",
      "item-value": "id",
      "hide-details": ""
    },
    on: {
      "change": function ($event) {
        return _vm.checkAccountIEC104Integration(_vm.formItem.accountId);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        parent,
        item
      }) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.name))]), _c(VListItemSubtitle, [_vm._v("ID: " + _vm._s(item.id))])], 1)];
      }
    }]),
    model: {
      value: _vm.formItem.accountId,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "accountId", $$v);
      },
      expression: "formItem.accountId"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.accountHint')))])], 1), _c(VCol, {
    staticClass: "pb-0 pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c(VTextarea, {
    attrs: {
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.description'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "dense": "",
      "name": "consumerDescription",
      "hide-details": ""
    },
    model: {
      value: _vm.formItem.description,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "description", $$v);
      },
      expression: "formItem.description"
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };